import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import Moment from 'react-moment';
import styled from 'styled-components';
import moment from 'moment';
import { GraphQLError } from 'graphql';

import * as graphql from 'generated/graphql';
import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

const Container = styled(Box)``;

const Message = styled(Box)`
	background: rgba(${(props) => toRgbString(props.theme.colors.red)}, 0.1);
	padding: 20px;
	border-radius: 8px;
	color: ${(props) => props.theme.colors.red};
`;

export default function EvaluationErrorCard(props: {
	error: GraphQLError;
	submission: graphql.EvaluationSubmission;
	lastSaved: Date;
}) {
	const { t } = useTranslation();

	const isValidationError =
		(props.error.extensions?.error as { name: string })?.name === 'ValidationError';

	return (
		<Container mb={3}>
			{isValidationError ? (
				<Message>
					{t('evaluations.submission.validation.error')}{' '}
					{props.submission.viewer.hasShared
						? t('evaluations.submission.autosave.submission')
						: t('evaluations.submission.autosave.concept')}{' '}
					<Moment interval={5000} fromNow>
						{moment(props.lastSaved)}
					</Moment>
					.
				</Message>
			) : (
				<Message>
					{t('evaluations.submission.autosave.error')}{' '}
					{props.submission.viewer.hasShared
						? t('evaluations.submission.autosave.submission')
						: t('evaluations.submission.autosave.concept')}{' '}
					<Moment interval={5000} fromNow>
						{moment(props.lastSaved)}
					</Moment>
					.
				</Message>
			)}
		</Container>
	);
}
